document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-hide-affixbottom="true"]');
    if (!elements.length) return;

    elements.forEach(el => {
        // Sentinel sits at the bottom of the element's natural position.
        // We observe this instead of el itself so that changing el's position
        // to fixed doesn't re-trigger the observer.
        const sentinel = document.createElement('div');
        sentinel.style.cssText = 'height:0;margin:0;padding:0;border:0;';
        el.parentNode.insertBefore(sentinel, el.nextSibling);

        // Placeholder holds the layout space while el is fixed.
        const placeholder = document.createElement('div');
        placeholder.setAttribute('aria-hidden', 'true');
        placeholder.style.display = 'none';
        sentinel.parentNode.insertBefore(placeholder, sentinel);

        let isAffixed = false;

        const syncPlaceholder = () => {
            const style = getComputedStyle(el);
            placeholder.style.height = el.offsetHeight + 'px';
            placeholder.style.marginTop = style.marginTop;
            placeholder.style.marginBottom = style.marginBottom;
        };

        const activate = () => {
            if (isAffixed) return;
            isAffixed = true;
            syncPlaceholder();
            placeholder.style.display = 'block';
            el.classList.add('is-affixed-bottom');
        };

        const deactivate = () => {
            if (!isAffixed) return;
            isAffixed = false;
            placeholder.style.display = 'none';
            el.classList.remove('is-affixed-bottom');
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // Sentinel is above viewport = user has scrolled past the block
                if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                    activate();
                } else {
                    deactivate();
                }
            });
        }, { threshold: 0 });

        observer.observe(sentinel);

        window.addEventListener('resize', () => {
            if (isAffixed) syncPlaceholder();
        });
    });
});
